import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum EditorPlatformPrivateAPIErrorCode {
  BuildManifestContextError = 'BuildManifestContextError',
  AttachProviderError = 'AttachProviderError',
  DetachProviderError = 'DetachProviderError',
  ListProvidersError = 'ListProvidersError',
  BindError = 'BindError',
  SetBindingError = 'SetBindingError',
  UnbindError = 'UnbindError',
  ListBindingsError = 'ListBindingsError',
  GetBindingError = 'GetBindingError',
  FindBindingCandidatesError = 'FindBindingCandidatesError',
  SelectBindingError = 'SelectBindingError',
  SelectSortError = 'SelectSortError',
  SelectFilterError = 'SelectFilterError',
  GetContextActionsError = 'GetContextActionsError',
}

class EditorPlatformError extends BaseError<EditorPlatformPrivateAPIErrorCode> {
  state: Partial<{
    url: string;
    appDefinitionId: string;
  }> = {};

  constructor(message: string, code: EditorPlatformPrivateAPIErrorCode) {
    super(message, code, 'EP Private API Error');
  }
}

export const createEditorPlatformPrivateAPIError = createErrorBuilder<
  EditorPlatformPrivateAPIErrorCode,
  EditorPlatformError
>(EditorPlatformError);
